import {Pipe, PipeTransform} from '@angular/core';
import {SpecLineModel} from "web-shared";

@Pipe({
  name: 'isSpecDuplicate'
})
export class IsSpecDuplicatePipe implements PipeTransform {
  transform(values: SpecLineModel[], propertyId: string, languageId: string, originId: string): boolean {
    return values.filter(spec => spec.PropertyId === propertyId && spec.LanguageId == languageId && (spec.OriginClv == originId || !originId || !spec.OriginClv)).length > 1;
  }
}
